import type { Array } from 'effect'
import type { LoanContext, LoanContextType } from './entities/loan-context'

export const contextTypeToUrlString = (
    context: Pick<LoanContext, 'type'>,
): 'invoice' | 'drawdown' => {
    return context.type === 'INVOICE' ? 'invoice' : 'drawdown'
}

export const urlStringToContextType = (urlString: string): LoanContextType => {
    return urlString === 'invoice' ? 'INVOICE' : 'DRAWDOWN'
}

/** The `[contextType]/[contextIds]` path segments, where `contextIds` is `a,b,c`. */
export const loanContextsToUrlPath = (
    loanContexts: Array.NonEmptyReadonlyArray<LoanContext>,
): string => {
    const contextIds = loanContexts.map(({ id }) => id).join(',')
    return `${contextTypeToUrlString(loanContexts[0])}/${contextIds}`
}
